import React from 'react';
import { Helmet } from 'react-helmet-async';
import AcronymHero from '../components/AcronymHero';
import AcronymNameGenerator from '../components/AcronymNameGenerator';
import AcronymFeatures from '../components/AcronymFeatures';
import AcronymHowItWorks from '../components/AcronymHowItWorks';
import AcronymTestimonials from '../components/AcronymTestimonials';
import AcronymGuide from '../components/AcronymGuide';
import AcronymSEOContent from '../components/AcronymSEOContent';
import AcronymFAQ from '../components/AcronymFAQ';
import AcronymCallToAction from '../components/AcronymCallToAction';

export default function AcronymPage() {
  return (
    <>
      <Helmet>
        <title>Acronym Generator | Create Meaningful & Memorable Acronyms</title>
      </Helmet>
      <AcronymHero />
      <AcronymNameGenerator />
      <AcronymFeatures />
      <AcronymHowItWorks />
      <AcronymTestimonials />
      <AcronymGuide />
      <AcronymSEOContent />
      <AcronymFAQ />
      <AcronymCallToAction />
    </>
  );
}